import { Component, Input } from '@angular/core';
import { FormArray } from '@angular/forms';

@Component({
  selector: 'afoone-wxrl-conditions-list',
  templateUrl: './wxrl-conditions-list.component.html',
  styleUrls: ['./wxrl-conditions-list.component.css']
})
export class WxrlConditionsListComponent {
  @Input()
  public conditionsFormArray: FormArray;

  @Input()
  public canEdit: boolean = false;

  get conditions() {
    return this.conditionsFormArray?.controls || [];
  }
}
